import { createStore } from '../../state'

import type { StateStorage } from 'zustand/middleware'

export interface BackupSeedStore {
  shouldBackupSeed: boolean
  setShouldBackupSeed: (shouldBackupSeed: boolean) => void
}

export const createBackupSeedStore = (storage: StateStorage) =>
  createStore<BackupSeedStore>(
    storage,
    (set) => ({
      shouldBackupSeed: false,
      setShouldBackupSeed: (shouldBackupSeed: boolean) => {
        set({ shouldBackupSeed })
      },
    }),
    {
      persist: {
        name: 'backupSeed',
        version: 0,
      },
    }
  )
